// extracted by mini-css-extract-plugin
module.exports = {"tutorials":"Tutorials_tutorials__QWLiV"};